import { Flex, Title, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ScatterChart } from 'components/Charts/ScatterChart/ScatterChart';
import { useWeightMeasurements } from 'hooks/api/useWeightData';
import { useBmiOptions, useWeightOptions } from 'components/Charts/ChartOptions/WeightBmiChartOptions';
import { PaperWithBorder } from 'components/PaperWithBorder';

export const WeightBmiCharts = () => {
  const { t } = useTranslation();
  const { isLoading } = useWeightMeasurements();
  const weightOptions = useWeightOptions();
  const bmiOptions = useBmiOptions();

  return (
    <PaperWithBorder isLoading={isLoading} title={t('weight_label')}>
      <Stack mt={'xs'}>
        <ScatterChart chartOptions={weightOptions} testId={'weight-chart'} />
        <Flex justify={'space-between'} align={'center'}>
          <Title order={4}>{t('bmi_label')}</Title>
        </Flex>
        <ScatterChart chartOptions={bmiOptions} testId={'bmi-chart'} />
      </Stack>
    </PaperWithBorder>
  );
};
